import React, { Component } from "react";

import { Form, Button, Col, Row, Input, Alert } from "antd";

import SizeType from "../../../../helpers/deviceTypeSize";

const { TextArea } = Input;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

class CategoryForm extends Component {
  state = {
    sameCategoryErrorVisbile: false,
    alertSuccessVisible: false,
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.saveCategory(values, this.showSuccess.bind(this));
      }
    });
  };

  isExsitsCategory = () => {
    const check = this.props.categories.find(
      (item) => item === this.props.form.getFieldsValue("name")
    );
    console.log(check);
    if (check !== undefined && check !== -1) {
      this.setState({ sameCategoryErrorVisbile: true });
    } else {
      this.setState({ sameCategoryErrorVisbile: false });
    }
  };

  showSuccess = () => {
    this.props.form.resetFields();
    this.setState({ alertSuccessVisible: true });
    setTimeout(() => {
      this.setState({ alertSuccessVisible: false });
    }, 3000);
  };

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;

    const alert = (
      <Alert
        style={{ marginBottom: "10px", zIndex: "1" }}
        message="Dogodila se greša"
        description="Dogodila se greška prilikom spremanja na server molimo vas probajte ponovo!"
        type="error"
      />
    );

    const alertSuccess = (
      <Alert
        style={{ marginBottom: "10px", zIndex: "1" }}
        message="Uspješno"
        description="Uspješno ste dodali kategoriju!"
        type="success"
      />
    );

    const alertSameCategory = (
      <Alert
        style={{ marginBottom: "10px", zIndex: "1" }}
        message="Dogodila se greša"
        description="Kategorija već postoji!"
        type="error"
      />
    );

    const formItemLayout = {
      labelCol: {
        span: 6,
      },
      wrapperCol:
        SizeType() === "xs" || SizeType() === "sm"
          ? {
              xs: {
                span: 24,
                offset: 0,
              },
              sm: {
                span: 16,
                offset: 0,
              },
            }
          : {
              span: 18,
              offset: 0,
            },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 24,
          offset: 0,
        },
      },
    };
    const layoutType =
      SizeType() === "xs" || SizeType() === "sm" ? "vertical" : "horizontal";

    const { category } = this.props;

    return (
      <React.Fragment>
        {this.state.alertSuccessVisible ? alertSuccess : null}
        {this.state.sameCategoryErrorVisbile ? alertSameCategory : null}
        {category.status === "error" ? alert : null}
        <Form
          {...formItemLayout}
          layout={layoutType}
          hideRequiredMark
          onSubmit={this.handleSubmit}
        >
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item className={'modal-header'} label="Kategorija:">
                {getFieldDecorator("name", {
                  initialValue: null,
                  rules: [
                    { required: true, message: "Unesite tekst!" },
                    { min: 3, message: "Minimalno znakova 3!" },
                  ],
                })(<TextArea />)}
              </Form.Item>
              <Form.Item {...tailFormItemLayout}>
                <Button
                  style={{ float: "right" }}
                  loading={category.status === "loading"}
                  type="primary"
                  htmlType="submit"
                  disabled={hasErrors(getFieldsError())}
                >
                  Spremi
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </React.Fragment>
    );
  }
}

export default Form.create()(CategoryForm);
